<template>
  <div class="mdc-form-field">
    <div :class="classes">
      <input
        :checked="checked"
        @change="handleChange"
        v-bind="$attrs"
        type="checkbox"
        :id="id"
        :disabled="disabled"
        class="mdc-checkbox__native-control"
        @focus="focused = true"
        @blur="focused = false"
      />
      <div class="mdc-checkbox__background">
        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
          <path class="mdc-checkbox__checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
        </svg>
        <div class="mdc-checkbox__mixedmark" />
      </div>
      <div class="mdc-checkbox__ripple"></div>
    </div>
    <label :for="id" v-if="$slots['default']" class="mdc-checkbox__label">
      <!-- @slot Checkbox label -->
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change"
  },
  data() {
    return {
      id: `am-checkbox-${this._uid}`,
      input: undefined,
      focused: false
    };
  },
  props: {
    /**
     * Checked state
     */
    checked: {
      type: Boolean,
      default: false
    },
    /**
     * Indeterminate state
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(e) {
      const { checked } = e.target;

      e.target.checked = this.checked;
      /**
       * Change event
       * @type {Boolean}
       */
      this.$emit("change", checked);
    }
  },
  mounted() {
    this.input = this.$el.querySelector("input");
    this.input.indeterminate = this.indeterminate;
  },
  watch: {
    indeterminate(value) {
      this.input.indeterminate = value;
    },
    checked(value) {
      if (value) {
        this.input.indeterminate = false;
      }
    }
  },
  computed: {
    classes() {
      return {
        "mdc-checkbox": true,
        "mdc-checkbox--disabled": this.disabled,
        "mdc-checkbox--selected": this.checked,
        "mdc-ripple-upgraded--background-focused": this.focused
      };
    }
  }
};
</script>
